/**
 * The PathShortcuts are intended to make it easier to write the path to a
 * component in the JSP file. They must match with the beginning of the
 * data-component attribute.
 */
const PathShortcuts: Record<string, string> = {};

export default PathShortcuts;
